module.exports = __webpack_public_path__ + "img/defensive_kodo_small.f21f3dda.png";